import { Pipe, PipeTransform } from '@angular/core';
import {Item} from "../../models/Item";
import {ConcreteHierarchyItemInterface} from "../concreteLayers/ConcreteHierarchyItemInterface";
import {TimelineService} from "../../services/timeline/timeline.service";
import {Group} from "../Groups/Group";

@Pipe({ name: 'groupByTimeline' })
export class GroupByTimeline implements PipeTransform {

  private resultObject;

  private getItemIndex(arr, item){
    for (let i=0; i<arr.length; i++){
      if (arr[i].getCHIId() == item.getCHIId()){
        return i;
      }
    }
   return null;
  }

  private getItem(arr, item){
    for (let i=0; i<arr.length; i++){
      if (arr[i].getCHIId() == item.getCHIId()){
        return arr[i];
      }
    }
    return null;
  }

  constructor(
    protected timelineService: TimelineService
  ) {
  }

  transform(itemsArr: any[] | null): { [key: string]: ConcreteHierarchyItemInterface[] } {
    if (!itemsArr || itemsArr.length === 0) {
      if (this.resultObject) {
        this.resultObject = null;
      }
      return {};
    }
    const resultObject: { [key: string]: ConcreteHierarchyItemInterface[] } = {};
    itemsArr.forEach((item) => {
      if (this.timelineService.isEnabled() && item instanceof Item) {
        let group = item.config.getInputProp('__timeline', 'value');
        group = (group || '-1');
        if (!resultObject.hasOwnProperty(group)) {
          resultObject[group] = [];
        }
        resultObject[group].push(item);
      } else {
        if (!resultObject['-1']) {
          resultObject['-1'] = [];
        }
        resultObject['-1'].push(item);
      }
     });

    if (!this.resultObject || Object.keys(resultObject).length === 0) {
      this.resultObject = resultObject;
    } else {
      for (const i in resultObject) {
        if (!this.resultObject.hasOwnProperty(i)) {
          this.resultObject[i] = [];
        }

        let oldArr = [];
        let newArr = [];
        const oldCHID = new Set(
          this.resultObject[i].map(arrItem => arrItem.getCHIId())
        );
        const newCHID = new Set(
          resultObject[i].map(arrItem => arrItem.getCHIId())
        );

        oldArr = this.resultObject[i].filter(itemObj => newCHID.has(itemObj.getCHIId()));
        newArr = resultObject[i].filter(itemObj => !oldCHID.has(itemObj.getCHIId()))

        oldArr = [...oldArr, ...newArr];

        this.resultObject[i] = oldArr;
      }
      //  sort
      for (const i in this.resultObject) {
        if (this.resultObject.hasOwnProperty(i)) {
          this.resultObject[i].sort((a, b) => {
            if (a instanceof Group && !(b instanceof Group)) {
              return -1;
            }
            if (!(a instanceof Group) && b instanceof Group) {
              return 1;
            }
            if (a instanceof Item && b instanceof Item) {
              const catNameA = a.config.getTool().category.name.toString().toLowerCase();
              const catNameB = b.config.getTool().category.name.toString().toLowerCase();
              return catNameA < catNameB ? -1 : 1;
            }
            return 0;
          });
        }
      }
    }
    return this.resultObject;
  }
}
